import type { UUID, ISODateString, Nullable } from './common';

// --- Enums ---

export const BILL_TYPES = ['equipment', 'carpet_cleaning'] as const;
export type BillType = (typeof BILL_TYPES)[number];

export const BILL_BILLING_STATUSES = ['draft', 'invoice_sent', 'paid'] as const;
export type BillBillingStatus = (typeof BILL_BILLING_STATUSES)[number];

// --- Job Bill ---

export interface JobBill {
  id: UUID;
  jobId: UUID;
  billType: BillType;
  billingStatus: BillBillingStatus;
  activeVersionId: Nullable<UUID>;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

// --- Versioning ---

export interface JobBillVersion {
  id: UUID;
  billId: UUID;
  name: string;
  snapshot: Record<string, unknown>;
  totalCost: number;
  createdBy: UUID;
  createdAt: ISODateString;
}
